var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldBox',{attrs:{"title":_vm.$t('trade.order-trail1-price-percent-label')}},[_c('PlusMinusInput',{attrs:{"precision":2,"min":0,"max":999999999,"step":0.01},model:{value:(_vm.trailingPercent),callback:function ($$v) {_vm.trailingPercent=$$v},expression:"trailingPercent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }